export const FINANCIAL_CODE_ZEROS = '0000'
export const FINANCIAL_CODE_XFERA = '8840'
export const FINANCIAL_CODE_CETELEM = '9999'
